import { render } from "./StoreForm.vue?vue&type=template&id=80642ce2&scoped=true"
import script from "./StoreForm.vue?vue&type=script&lang=js"
export * from "./StoreForm.vue?vue&type=script&lang=js"

import "./StoreForm.vue?vue&type=style&index=0&id=80642ce2&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80642ce2"]])

export default __exports__